import { Observable } from 'rxjs/Observable'

import { FETCH_APP_DATA_ASYNC } from 'containers/App/constants'
import { SUBMIT_CUSTOMIZED_AUTO_SYNC_ASYNC } from 'containers/CustomizedAutoSync/constants'
import { AS_GD_ASYNC, AS_O365_ASYNC } from 'containers/Mailboxes/constants'
import {
  QUICK_INTEGRATION_CONTINUE,
  QUICK_INTEGRATION_SAVE_ASYNC,
} from 'containers/Settings/EmailServer/QuickIntegration/constants'

import { fetchDemoBannerStatusError, fetchDemoBannerStatusSuccess } from './actions'

const fetchDemoBannerStatus = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      FETCH_APP_DATA_ASYNC.INITIATE,
      AS_O365_ASYNC.SUCCESS,
      AS_GD_ASYNC.SUCCESS,
      SUBMIT_CUSTOMIZED_AUTO_SYNC_ASYNC.SUCCESS,
      QUICK_INTEGRATION_SAVE_ASYNC.SUCCESS,
      QUICK_INTEGRATION_CONTINUE
    )
    .mergeMap(() =>
      api.accounts
        .getDemoBannerStatus(store.getState().partnerOptions.selectedCompany?.value)
        .map((response) => fetchDemoBannerStatusSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(fetchDemoBannerStatusError, error)))
        .takeUntil(action$.ofType(FETCH_APP_DATA_ASYNC.CANCEL))
    )

export default fetchDemoBannerStatus
